/* eslint-disable no-param-reassign */
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { EditOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import './style.scss';
import HideValue from '../../../../../Common/RestrictedAccess/HideValue';

/**
 *
 */
class OtherChargeEntry extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    const { priceMasking } = props;
    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
    this.state = {
      productListColumns: [
        {
          title: 'Charge Name',
          render: (text, record) => (
            <div className="oc-table-estimated-amount__wrapper">
              {record.charge_name}
            </div>
          ),
        },
        {
          title: 'Estimated Amount',
          width: '180px',
          render: (text, record) => (
            <div className="oc-table-estimated-amount__wrapper">
              {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view estimated cost"} /> : this.props.MONEY(record.charge_amount)}
            </div>
          ),
        },
      ],
    };
  }

  /**
   *
   */
  componentDidMount() {
  }

  /**
   *
   * @param {*} data
   * @return
   */
  getDataSource(data) {
    if (data) {
      return JSON.parse(JSON.stringify(data));
    }
    return [];
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      data, loading,
    } = this.props;
    const {
      productListColumns,
    } = this.state;
    return (
      <Fragment>
        <div className="mpe-oc__wrapper">
          <Table
            bordered
            loading={loading}
            showHeader
            size="small"
            scroll="scroll"
            columns={productListColumns}
            dataSource={this.getDataSource(data)}
            pagination={false}
          />
        </div>

      </Fragment>
    );
  }
}

/**
 *
 * @param UserReducers
 * @param PurchaseOrderReducers
 * @return {{updateCustomPurchaseOrderLoading: *, selectedPurchaseOrder, user}}
 */
const mapStateToProps = ({
  UserReducers, PurchaseOrderReducers, OfferReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  updateCustomPurchaseOrderLoading: PurchaseOrderReducers.updateCustomPurchaseOrderLoading,
  selectedPurchaseOrder: PurchaseOrderReducers.selectedPurchaseOrder,
  getOfferByTenantSkuLoading: OfferReducers.getOfferByTenantSkuLoading,
  priceMasking: UserReducers.priceMasking,
});

/**
 *
 * @return {{}}
 */
const mapDispatchToProps = () => ({

});

OtherChargeEntry.propTypes = {
  loading: PropTypes.bool,
  updateData: PropTypes.func,
  data: PropTypes.any,
  isFlexible: PropTypes.bool,
  handleDelete: PropTypes.any,
  createMOLoading: PropTypes.bool,
  updateMOLoading: PropTypes.bool,
  formSubmitted: PropTypes.bool,
  multipleFG: PropTypes.bool,
  handleChargeChange: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OtherChargeEntry));
